<template>
  <InvestorGateRoute
    auth-scope="pitch"
    storage-key="investor_pitch_auth"
    analytics-source="pitch_gate"
    :deck-loader="loadDeck"
  />
</template>

<script>
import InvestorGateRoute from '@/components/InvestorGateRoute.vue';
import ensureInvestorDeckLoaded from '@/lib/investorChunkLoader';

export default {
  name: 'InvestorDeep',
  components: { InvestorGateRoute },
  methods: {
    async loadDeck() {
      // Pre-populate webpack's chunk registry from the auth-gated endpoint
      // so the dynamic import below resolves from cache without ever
      // requesting the (intentionally absent) public chunk URL.
      await ensureInvestorDeckLoaded('pitch');
      return import(
        /* webpackChunkName: "investor-deep-deck" */ './InvestorDeepDeck.vue'
      );
    },
  },
};
</script>
